import React, { FC, ReactElement, useEffect, useState } from 'react'
import { ManageQueues as ManageQueuesLanguage } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import Modal from '../../Common/Components/Modal'
import { StandardContexts } from '../../Common/Components/StandardContexts'
import { ModalContextProvider } from '../../Common/Contexts/ModalContext'
import { ReactState } from '../../Common/Types/Types'
import { ManageQueues } from '../Main/ManageQueues'
import { clearModalHelpTopic, setModalHelpTopicID } from '../../Common/Utils/HelpPortal'
import { DocTopic } from '../../Common/Constants/Documentation'
import { $window } from '../../../NonReact/common/AkixiWindow'

export const ManageQueuesModal: FC = (): ReactElement => {
    // Access language resources directly without context as this is top level component.
    const language: CLanguageHandler = CLanguageHandler.getInstance()
    language.loadBundle(ManageQueuesLanguage.NAME)

    // Whether the modal window is open.
    const [isModalOpen, setModalOpen]: ReactState<boolean> = useState<boolean>(true)
    const [modalTitle, setModalTitle]: ReactState<string> = useState<string>(language.get(ManageQueuesLanguage.Title))

    const closeModal = (): void => {
        $window.disableHotKeys = false
        // Component is controlled externally.
        setModalOpen(false)
        clearModalHelpTopic()
    }

    useEffect(() => {
        setModalHelpTopicID(DocTopic.MANAGE_QUEUES)
    }, [])

    return (
        <ModalContextProvider
            modalInput={{
                closeModal,
                setModalTitle
            }}
        >
            <StandardContexts>
                <Modal
                    isOpen={isModalOpen}
                    closeOnBackdropClick={false}
                    isClosableWithXButton={true}
                    onClose={closeModal}
                >
                    <div className='modal-title-report-config'>{modalTitle}</div>
                    <ManageQueues />
                </Modal>
            </StandardContexts>
        </ModalContextProvider>
    )
}
